import { ErrorType } from '../models/clux/enum';

export const errorTypeMap: Record<string, ErrorType> = {
  individualNotUniqueEmail: ErrorType.IndividualNotUniqueEmail,
  exceedsOverallMaximumLimit: ErrorType.ExceedsOverallMaximumLimit,
  exceedsBenefitPlanEmployerMaximumLimit: ErrorType.ExceedsBenefitPlanEmployerMaximumLimit,
  exceedsBenefitPlanEmployeeMaximumLimit: ErrorType.ExceedsBenefitPlanEmployeeMaximumLimit,
};

/** Plan-limit-exceeded ErrorTypes - callers handle these inline, so the generic apiFailure growler must be suppressed for them. */
export const PLAN_LIMIT_ERROR_TYPES: ErrorType[] = [
  ErrorType.ExceedsBenefitPlanEmployeeMaximumLimit,
  ErrorType.ExceedsBenefitPlanEmployerMaximumLimit,
  ErrorType.ExceedsOverallMaximumLimit,
];
